
import apiClient from '../helpers/apiClient';
import { authHeader } from '../helpers/authHeader';



export const rewardService = {
    submitRedeemContent,
    submitEarnContent,
    submitFAQContent,
    getEarnContent,
    updateEarnContent,
    updateFaqContent,
    getRewardHistory,
    updateRewardTableSequence,
    rewardHistoryDetails,
    getRewardRedeemList,
    getCarrierBagList,
    carrierDetails,
    createNewReturn,
    updateReturn,
    deleteReturn,
    rewardByDate, 
    rewardSearch,
    rewardRedeemByDate,
    rewardRedeemSearch

    
 
};



async function  submitRedeemContent(data) {
    return  apiClient.post(`/rewards/submit-redeem-content`,data, authHeader());
}


async function  submitEarnContent(data) {
    return  apiClient.post(`/rewards/submit-earn-content`,data, authHeader());
}

async function  updateEarnContent(data) {
    return  apiClient.put(`/rewards/update-earn-content`,data, authHeader());
}

async function  submitFAQContent(data) {
    return  apiClient.post(`/rewards/submit-faq-content`,data, authHeader());
}


async function  updateFaqContent(data) {
    return  apiClient.put(`/rewards/update-faq-content`,data, authHeader());
}


async function  getEarnContent() {
    return  apiClient.get(`/rewards/get-earn-content`, authHeader());
}



async function  getRewardHistory() {
    return  apiClient.get(`/rewards/reward-history`, authHeader());
}


async function  rewardSearch(searchText) {
    return  apiClient.get(`/rewards/reward-search?search=${searchText}`, authHeader());
}


async function  rewardByDate(form) {
    return  apiClient.post(`/rewards/reward-by-date`, form, authHeader());
}
async function  rewardRedeemSearch(searchText) {
    return  apiClient.get(`/rewards/reward-redeem-search?search=${searchText}`, authHeader());
}


async function  rewardRedeemByDate(form) {
    return  apiClient.post(`/rewards/reward-redeem-by-date`, form, authHeader());
}


async function  updateRewardTableSequence(data) {
    return  apiClient.put(`/rewards/update-reward-table-sequence`,data, authHeader());
}

async function  rewardHistoryDetails(id) {
    return  apiClient.get(`/rewards/reward-details/${id}`, authHeader());
}

async function  getRewardRedeemList() {
    return  apiClient.get(`/rewards/reward-redeem`, authHeader());
}

async function  getCarrierBagList() {
    return  apiClient.get(`/rewards/carrier-bag-list`, authHeader());
}


async function  carrierDetails(id) {
    return  apiClient.get(`/rewards/carrier-details/${id}`, authHeader());
}



async function  createNewReturn(form) {
    return  apiClient.post(`/rewards/create-new-return`,form, authHeader());
}

async function  updateReturn(form) {
    return  apiClient.put(`/rewards/update-return`,form, authHeader());
}


async function  deleteReturn(id) {
    return  apiClient.delete(`/rewards/delete-return/${id}`, authHeader());
}















